import React from 'react';
import assign from 'lodash/assign';
import noop from 'lodash/noop';

import AddWidgetModal from 'components/AddWidgetModal/AddWidgetModal';

export default class AppComponent extends React.Component {
  constructor(props) {
    super(props);
    this.handleAddWidgetModalOnHide = this.handleAddWidgetModalOnHide.bind(this);
    this.handleAddWidgetModalOnSuccess = this.handleAddWidgetModalOnSuccess.bind(this);

    this.state = {
      isAddWidgetModalOpen: false,
      addWidgetModalOnSuccess: noop,
      widgetData: [],
      readingLists: []
    };
  }

  componentDidMount() {
    document.body.addEventListener(
      'react:open_AddWidgetModal',
      (e) => {
        this.setState({ // eslint-disable-line react/no-did-mount-set-state
          isAddWidgetModalOpen: true,
          readingLists: e.detail.readingLists.map((readingList) => {
            const storiesLength = readingList.stories.length;
            return assign({
              type: 'ReadingListsWidget:' + readingList.id,
              icon: 'ReadingList',
              count: 0,
              description: storiesLength + (storiesLength === 1 ? ' story ' : ' stories')
            }, readingList);
          }),
          widgetData: e.detail.widgets.concat(e.detail.customWidgets),
          addWidgetModalOnSuccess: e.detail.onSuccess,
          onSaveCustomWidget: e.detail.onSaveCustomWidget,
          fileUploadUrl: e.detail.fileUploadUrl,
          deleteCustomWidget: e.detail.deleteCustomWidget,
          widgetIdsOnDashboard: e.detail.widgetIdsOnDashboard
        });
      }
    );
  }

  handleAddWidgetModalOnHide() {
    this.setState({isAddWidgetModalOpen: false});
  }

  handleAddWidgetModalOnSuccess(widgetsToAdd) {
    this.setState({isAddWidgetModalOpen: false});
    this.state.addWidgetModalOnSuccess(widgetsToAdd);
  }

  render() {
    return (
      <AddWidgetModal
        isOpen={this.state.isAddWidgetModalOpen}
        onHide={this.handleAddWidgetModalOnHide}
        onSuccess={this.handleAddWidgetModalOnSuccess}
        onSaveCustomWidget={this.state.onSaveCustomWidget}
        data={this.state.widgetData}
        readingLists={this.state.readingLists}
        fileUploadUrl={this.state.fileUploadUrl}
        deleteCustomWidget={this.state.deleteCustomWidget}
        widgetIdsOnDashboard={this.state.widgetIdsOnDashboard}
      />
    );
  }
}
